const options = {
    method: 'GET',
    headers: {
        Accept: 'application/json',
    },
};

const parseJson = async (res) => {
    if (res.status >= 200 && res.status < 300) {
        return res.json().then((data) => ({ status: res.status, data }));
    }
    return Promise.resolve({ status: res.status });
};

export const fetchData = (latSw, lngSw, latNe, lngNe) =>
    fetch(`/travel-api/fhh/list?lat_sw=${latSw}&lng_sw=${lngSw}&lat_ne=${latNe}&lng_ne=${lngNe}`, options)
        .then((res) => parseJson(res))
        .catch((error) => ({ error }));
